import React from "react";
import clsx from "clsx";
import RoomTypeBuilderCategory from "./RoomTypeBuilderCategory";

class RoomTypeBuilderCategories extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.amenities_active_tab == 'categories',
      'tab-pane': true,
      'card': true
    })
    
    return (
      <div className={tabClasses} id="categories">
        <div className="container">
            {this.renderSelectedCategories()}
        </div>
      </div>
    );
  };

  renderSelectedCategories = () => {
    var self = this;

    if (this.props.categories) {
      var categories = this.props.categories
        .sort((a, b) => a.position - b.position)
        .reduce(function (acc, category) {
            acc.push(
              <RoomTypeBuilderCategory
                category={category}
                key={category.id}
                ru_amenities={self.props.ru_amenities}
                onChange={self.props.onChange}
                onChangeAmenities={self.props.onChangeAmenities}
                onAddAmenity={self.props.onAddAmenity}
              />
            );
          return acc;
        }, []);
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100% - 56px)",
        }}
      >
        {categories && categories.length > 0 ? (
          <div className="categories">{categories}</div>
        ) : (
          <div className="no-records"><span className="none">{I18n.t('none')}</span></div>
        )}
      </div>
    );
  };
};

export default RoomTypeBuilderCategories